import { createObject, employeeChoices } from "./serializeEmployeeChoices.js";

export const taskOwners = (choices) => {
    const owners = {};

    choices.forEach(piece => {
        piece.tasks.forEach(task => {
            owners[task.task_id] = piece.piece_id;
        });
    });

    return owners;
};

export const selectFreeTasks = (piece) => {
    const owners = taskOwners(employeeChoices);

    piece.tasks.forEach(task => {
        if (owners[task.task_id] === undefined) {
            createObject(piece, task);
        }
    });
};
